import React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  ReferenceInput,
  AutocompleteInput,
  FormDataConsumer,
  email,
  required,
} from "react-admin";

import { CUSTOMER_ADMINISTRATOR } from "../authProvider/roles";
import FormContainer from "../common/FormContainer";
import { PasswordInput } from "../common/PasswordInput";
import useCreateWithValidation from "../common/useCreateWithValidation";
import RoleSelectInput from "./RoleSelectInput";

const AccountCreate = () => {
  const save = useCreateWithValidation("Account", { redirectTo: "show" });

  return (
    <Create>
      <SimpleForm onSubmit={save}>
        <FormContainer>
          <TextInput
            source="emailAddress"
            validate={[required(), email()]}
            fullWidth
          />
          <PasswordInput source="password" validate={required()} fullWidth />
          <RoleSelectInput source="role" validate={required()} />
          <FormDataConsumer>
            {({ formData, ...rest }) =>
              formData.role === CUSTOMER_ADMINISTRATOR && (
                <ReferenceInput
                  source="customerId"
                  reference="Customer"
                  sort={{ field: "name", order: "ASC" }}
                  filterToQuery={(searchText: any) => ({
                    q: searchText,
                  })}
                  {...rest}
                >
                  <AutocompleteInput optionText="name" fullWidth validate={required()} />
                </ReferenceInput>
              )
            }
          </FormDataConsumer>
        </FormContainer>
      </SimpleForm>
    </Create>
  );
};
export default AccountCreate;
